/* eslint-disable react/require-default-props */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
// Imported components
import DisruptionIndicatorMedium from 'components/shared/DisruptionIndicator/DisruptionIndicatorMedium';
import CloseButton from './CloseButton/CloseButton';
import s from './SelectedServiceHeader.module.scss';

function SelectedServiceHeader({
  autoCompleteState,
  autoCompleteDispatch,
  mode = 'bus',
  to = false,
}) {
  const { selectedItem, selectedItemTo, selectedLocation } = autoCompleteState;
  const selectedServiceRef = useRef(null);

  const selectedService = to ? selectedItemTo : selectedItem;

  useEffect(() => {
    // Wrapped in useEffect as it is reliant on functionality from the useEffect in MobileTray.js
    if (
      ((mode === 'train' &&
        autoCompleteState.selectedItem.id &&
        autoCompleteState.selectedItemTo.id) ||
        (mode !== 'train' && selectedService.id)) &&
      selectedServiceRef.current &&
      document.getElementById('js-disruptions-tray')
    ) {
      // Scroll the tray to the clicked disruption
      const { offsetTop } = selectedServiceRef.current;
      const tray = document.getElementById('js-disruptions-tray'); // Get ID of tray from MobileTray.js or Tray.js
      tray.scrollTop = offsetTop - 2; // Scroll to the disruption ref'd below minus 2 pixels
    }
  }, [
    autoCompleteState.selectedItem.id,
    autoCompleteState.selectedItemTo.id,
    mode,
    selectedService.id,
  ]);

  return (
    <>
      {/* Close disruption box */}
      {(!selectedService.selectedByMap || mode === 'roads') && (
        <div
          className={`wmnds-grid wmnds-grid--align-center wmnds-m-t-xs wmnds-m-b-md ${s.selectedItemBox}`}
          ref={selectedServiceRef}
        >
          {mode !== 'roads' && (
            <DisruptionIndicatorMedium
              className="wmnds-p-t-xs wmnds-p-b-xs wmnds-p-l-xsm wmnds-p-r-xsm wmnds-col-auto wmnds-m-r-sm"
              severity={mode === 'bus' ? 'purple' : selectedService.severity}
              text={selectedService.serviceNumber || null}
              noMarginOnIcon={mode !== 'bus'}
            />
          )}
          <strong
            className={`wmnds-col-auto ${s.selectedSummary} ${
              mode === 'roads' ? 'wmnds-m-l-sm' : null
            }`}
          >
            {selectedService.routeName || selectedService.stopName || selectedLocation.address}
          </strong>

          <CloseButton onClick={autoCompleteDispatch} />
        </div>
      )}
    </>
  );
}

// PropTypes
SelectedServiceHeader.propTypes = {
  autoCompleteState: PropTypes.shape({
    selectedItem: PropTypes.shape({
      id: PropTypes.string,
      routeName: PropTypes.string,
      serviceNumber: PropTypes.string,
      selectedByMap: PropTypes.bool,
      severity: PropTypes.string,
    }),
    selectedItemTo: PropTypes.shape({
      id: PropTypes.string,
      routeName: PropTypes.string,
      serviceNumber: PropTypes.string,
      selectedByMap: PropTypes.bool,
      severity: PropTypes.string,
    }),
    selectedLocation: PropTypes.shape({
      address: PropTypes.string,
    }),
  }).isRequired,
  autoCompleteDispatch: PropTypes.func.isRequired,
  mode: PropTypes.string,
  to: PropTypes.bool,
};

export default SelectedServiceHeader;
